import { useQuery } from "@tanstack/react-query";

import { marketplaceApi } from "@/features/marketplace/services/marketplace.api";

export function useProduct(slug: string) {
  return useQuery({
    queryKey: ["products", "detail", slug],
    queryFn: () => marketplaceApi.getProductBySlug(slug),
  });
}
